import { createContext } from 'react';

export const PageChangeContext = createContext<{
  pageUrlChanged?: string;
  getCurrentPath: () => string;
}>({
  pageUrlChanged: undefined,
  getCurrentPath: () => '',
});
